import switchFunc from 'lib/switchFunc'

export const TOUR_V2_ROOM_TYPE: Partial<Record<Tours.V2OfferRoomType, string>> = {
  single_regular: 'Regular',
  twin_regular: 'Regular',
  single_vip: 'VIP',
  twin_vip: 'VIP',
  single_platinum: 'Platinum',
  twin_platinum: 'Platinum',
}

const formatPackageOptionType = switchFunc(TOUR_V2_ROOM_TYPE, '')

export default formatPackageOptionType
